module.exports = __webpack_public_path__ + "static/media/project11.89f901f1.png";